
  export default {
    name: 'CartButton',
    props: {
      itemIds: {
        type: Array,
        required: true
      },
      productId: {
        type: [String, Number],
        required: false
      },
      product: {
        type: Object,
        default: {}
      },
      config: {
        type: Object,
        default: {}
      }
    },
    data(){
      return {
        canShow: false,
        learnMoreLink: 'https://truefire.com'
      }
    },
    created(){
       // v-if="(product.user && (!product.user.owns)) || !product.user"
      if(this.config && (this.config.elements && (this.config.elements.includes('cart'))) &&
        (!this.product.user || (this.product.user && !this.product.user.access)))
        this.canShow = true
        this.learnMoreLink = this.config?.marketing?.powered_by_link || 'https://truefire.com'
    }

  }
  